export const hasTextSpaces = (text, symbol = "_") => {
  return text.replace(/[а-яА-ЯёЁ]/g, "").replace(/\s/gm, symbol);
};
